
import { createFileRoute } from '@tanstack/react-router'
import { GameHistory } from '../components/games/history'

export const Route = createFileRoute('/')({
	component: Index,
})

/**
 * #0a97ab 
 * #bf1e36
 */

function Index() {
	return <GameHistory />
}